<template>
    <vx-table-row>
        <vx-table-row-title class="xl:col-span-2! break-words">
            {{ model.id === userId ? 'You' : model.name }}
            <div class="text-sm text-slate-500 font-normal mt-1">{{ model.email }}</div>
            <outside-verified-domains-badge
                v-if="model.email_domain_verified === false && props.requireSso"
                :email="model.email"
                class="mt-1"
            />
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Role: </template>
            {{ GROUP_USER_ROLES[model.role] || '-' }}
        </vx-table-row-item>

        <vx-table-row-buttons v-if="props.canManageUsers">
            <vx-button
                @click="confirmDelete"
                data-test="delete"
                color="muted"
                outline>
                <font-awesome-icon widthAuto :icon="faCircleMinus" />
            </vx-button>

            <vx-button
                @click="emit('edit')"
                data-test="edit"
                color="muted"
                outline>
                Edit <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>

    </vx-table-row>
</template>

<script setup>
import {
    faCircleMinus,
    faFilePen,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxSwal,
} from '@voxie/frontend-components';
import { useToasted } from '~/composables/useToasted';
import { GROUP_USER_ROLES } from "~/constants/roles";
import { groupUsersClient } from "~/services";
import { throwSwalRequestError } from '~/utils/request';
import OutsideVerifiedDomainsBadge from '~/components/settings/teams/sso/OutsideVerifiedDomainsBadge.vue';

const toasted = useToasted();
const userId = Spark.state.user.id;

const model = defineModel({
    type: Object,
    required: true,
});

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
    canManageUsers: {
        type: Boolean,
        default: false,
    },
    requireSso: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['deleted', 'edit']);

const confirmDelete = () => {
    VxSwal.confirmation(
        'Are you sure?',
        'The user will immediately lose access to this group.',
        'warning',
        () => groupUsersClient.deleteGroupUser(props.teamId, props.groupId, model.value.id)
            .then(() => {
                toasted.success(`${model.value.name || model.value.email} removed from Group`);
                emit('deleted');
            })
            .catch(throwSwalRequestError),
    );
};

</script>
